module.exports = __webpack_public_path__ + "img/Table_top190.aafe1556.png";